export default __webpack_public_path__ + "static/media/img_13.ca14bdf4.png";